import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"
import { Box, Button, Card, CardContent, CardHeader, FormControl, Grid, IconButton, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import httpReq from "../../../services/httpReq"
import SaveIcon from '@mui/icons-material/Save'
import CloseIcon from '@mui/icons-material/Close'

const ModalAddUser = ({ isMobile, isOpen, setIsOpen, userRolesList }) => {
  const { control, formState, handleSubmit, getValues } = useForm({
    mode: 'onChange',

  })
  const [selectedUserRole, setSelectedUserRole] = useState(null)
  const { _ } = useLingui()


  const handleUserRole = (value) => {
    const findUserRole = userRolesList.find(u => {
      return u.description === value.target.value
    })
    setSelectedUserRole(findUserRole)
  }

  const addUser = async () => {
    const values = getValues()
    values.profile = selectedUserRole

    const dataToSend = {
      id: 0,
      username: values.username,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      mobile: values.mobile,
      profileFk: values.profile.id
    }
    const res = await httpReq(`User/Insert`, 'POST', dataToSend, true)
    if (!res || res.responseAnyError) return;
    if (!res.responseAnyError) {
      setIsOpen(false)
    }
  }

  if (!userRolesList || userRolesList.length === 0) {
    return (
      <></>
    )
  }
  return (
    <Modal sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} open={isOpen}>
      <Card sx={{ width: !isMobile ? '50vw' : '100vw', height: isMobile ? '100vh' : '80vh' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 1.5,
          }}
        >
          <Box sx={{ flex: 1 }} />

          <Typography variant="h6" align="center" sx={{ flex: 1 }}>
            {`Add user`}
          </Typography>

          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <IconButton sx={{ borderRadius: 10 }} variant="contained" disabled={!formState.isValid} onClick={() => addUser()}>
              <SaveIcon color={!formState.isValid ? 'inherit' : 'white'} />
            </IconButton>
            <IconButton onClick={() => setIsOpen(false)}><CloseIcon color="error" /></IconButton>
          </Box>
        </Box>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Controller
                name='username'
                control={control}
                defaultValue=""
                render={({ field, fieldState }) => (
                  <TextField
                    margin={isMobile ? 'dense' : 'normal'}
                    fullWidth
                    required
                    label={_(msg`Username`)}
                    autoComplete='username'
                    autoFocus
                    error={!!fieldState.error}
                    helperText={fieldState.error ? fieldState.error.message : null}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name='completeName'
                control={control}
                defaultValue=""
                render={({ field, fieldState }) => (
                  <TextField
                    margin={isMobile ? 'dense' : 'normal'}
                    fullWidth
                    required
                    label={_(msg`Complete name`)}
                    autoComplete='completeName'
                    autoFocus
                    error={!!fieldState.error}
                    helperText={fieldState.error ? fieldState.error.message : null}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name='email'
                control={control}
                defaultValue=""
                render={({ field, fieldState }) => (
                  <TextField
                    margin={isMobile ? 'dense' : 'normal'}
                    fullWidth
                    required
                    label={_(msg`Email`)}
                    autoComplete='email'
                    autoFocus
                    error={!!fieldState.error}
                    helperText={fieldState.error ? fieldState.error.message : null}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name='firstName'
                control={control}
                defaultValue=""
                render={({ field, fieldState }) => (
                  <TextField
                    margin={isMobile ? 'dense' : 'normal'}
                    fullWidth
                    required
                    label={_(msg`First name`)}
                    autoComplete='firstName'
                    autoFocus
                    error={!!fieldState.error}
                    helperText={fieldState.error ? fieldState.error.message : null}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name='lastName'
                control={control}
                defaultValue=""
                render={({ field, fieldState }) => (
                  <TextField
                    margin={isMobile ? 'dense' : 'normal'}
                    fullWidth
                    required
                    label={_(msg`Last name`)}
                    autoComplete='lastName'
                    autoFocus
                    error={!!fieldState.error}
                    helperText={fieldState.error ? fieldState.error.message : null}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sx={{display:'flex',alignItems:'center',justifyContent:'center',marginTop:1}}>
              <FormControl sx={{ width: '100%' }}>
                <InputLabel id="label-select-user-role">Role</InputLabel>
                <Select
                  label={'Role'}
                  value={selectedUserRole?.description}
                  onChange={(e) => { handleUserRole(e) }} sx={{ width: '100%' }} labelId="label-select-user-role">
                  {userRolesList.map((userRole, k) => {
                    return (
                      <MenuItem key={k} value={userRole.description}>{userRole.description}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Modal>
  )
}
export default ModalAddUser